module.exports = __webpack_public_path__ + "img/process.1357b461.png";